<mat-table [dataSource]="dataSource" class="uw-table">

	<ng-container matColumnDef="lowerRangeAmount">
	  <mat-header-cell class="uw-header-cell" *matHeaderCellDef> {{ "profile.last_year_gift_greater_than" | translate }} </mat-header-cell>
	  <mat-cell *matCellDef="let suggestedAmount">{{ suggestedAmount.lowerRangeAmount  | currency:'':'symbol-narrow':'1.2-2':currentLanguage }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="upperRangeAmount">
	  <mat-header-cell mat-header-cell *matHeaderCellDef class="uw-header-cell"> {{ "profile.last_year_gift_less_than/equal_to" | translate }} </mat-header-cell>
	  <mat-cell *matCellDef="let suggestedAmount">{{ suggestedAmount.upperRangeAmount | currency:'':'symbol-narrow':'1.2-2':currentLanguage  }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="languageCode">
	  <mat-header-cell class="uw-header-cell"  mat-header-cell *matHeaderCellDef> {{ "common.language" | translate }} </mat-header-cell>
	  <mat-cell *matCellDef="let suggestedAmount">{{ suggestedAmount.languageCode }}</mat-cell>
	</ng-container>

	<ng-container matColumnDef="suggestedAmounts">
	  <mat-header-cell class="uw-header-cell"  mat-header-cell *matHeaderCellDef> {{ "profile.suggested_amounts" | translate }} </mat-header-cell>
	  <mat-cell *matCellDef="let suggestedAmount">{{  suggestedAmount.suggestedAmountType?.toLowerCase() !== 'percentage' ? (suggestedAmount.firstAmount | currency:'':'symbol-narrow':'1.2-2':currentLanguage ) : suggestedAmount.firstAmount + '%' }}
      , {{ suggestedAmount.suggestedAmountType?.toLowerCase() !== 'percentage' ? (suggestedAmount.secondAmount | currency:'':'symbol-narrow':'1.2-2':currentLanguage ) : suggestedAmount.secondAmount + '%' }},
      {{ suggestedAmount.suggestedAmountType?.toLowerCase() !== 'percentage' ? (suggestedAmount.thirdAmount | currency:'':'symbol-narrow':'1.2-2':currentLanguage ) : suggestedAmount.thirdAmount + '%' }}</mat-cell>

	</ng-container>

	<ng-container matColumnDef="actions">
	  <mat-header-cell class="uw-header-cell"  mat-header-cell *matHeaderCellDef></mat-header-cell>
	  <mat-cell *matCellDef="let suggestedAmount">
      <div class="suggested-amount-list__actions-container">
        <span tabindex="0" role="button" class="uw-pill" (keydown)="onEditKeydown($event, suggestedAmount)" (click)="edit.emit(suggestedAmount)">{{ "common.edit" | translate }}</span>
        <span tabindex="0" role="button" class="uw-pill" (keydown)="onRemoveKeydown($event, suggestedAmount)" (click)="delete.emit(suggestedAmount)">{{ "common.delete" | translate }}</span>
      </div>
	  </mat-cell>
	</ng-container>

	<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
	<mat-row *matRowDef="let suggestedAmount; columns: displayedColumns;"></mat-row>

  </mat-table>
